import { render } from "./MicroContainer.vue?vue&type=template&id=df2a72de"
const script = {}

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_wnetg4mc3cpyffc4m6niwqjmd4/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__